declare namespace $ {

	export class $mol_icon_xml extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=xml.view.tree.d.ts.map